<template>
  <teleport to="body" v-if="props.visible">
    <div class="dialog-overlay" @click="handleOverlayClick">
      <div
        class="dialog-content"
        :class="[props.dialogClass, { 'dialog-content-no-title': !props.title }]"
      >
        <img
          class="dialog-decorated-image"
          v-if="props.decoratedImage"
          :src="props.decoratedImage"
        />
        <div class="dialog-close-icon" v-if="props.showClose" @click="handleCloseIconClick">
          <span class="hitems-close"></span>
        </div>
        <slot name="header-image">
          <img :src="props.headerImage" class="dialog-header-image" />
        </slot>
        <div class="dialog-content-container">
          <slot name="content">
            <div v-if="props.title" class="dialog-title">{{ props.title }}</div>
            <div class="dialog-description" v-if="props.description">{{ props.description }}</div>
          </slot>
        </div>
        <slot name="footer">
          <div class="dialog-primary-button" @click="handleConfirmClick">
            <slot name="confirm-text">
              {{ confirmText }}
            </slot>
          </div>
        </slot>
      </div>
    </div>
  </teleport>
</template>

<script setup lang="ts">
  import { watch } from 'vue'
  type IDialogProps = {
    visible: boolean
    title?: string
    description?: string
    confirmText?: string
    decoratedImage?: string
    headerImage?: string
    showClose?: boolean
    closeByMask?: boolean
    allowClose?: boolean
    dialogClass?: string
  }

  defineOptions({ name: 'AppDialog' })
  const emit = defineEmits(['close', 'confirm', 'show'])
  const props = withDefaults(defineProps<IDialogProps>(), {
    showClose: true,
    closeByMask: false,
    allowClose: true
  })
  watch(
    () => props.visible,
    isVisible => {
      if (isVisible) {
        emit('show')
      }
    }
  )
  const handleOverlayClick = () => {
    if (!props.allowClose) return
    if (props.closeByMask) {
      emit('close')
    }
  }
  const handleCloseIconClick = () => {
    if (!props.allowClose) return
    emit('close')
  }
  const handleConfirmClick = () => {
    emit('confirm')
  }
</script>

<style scoped lang="stylus">
  @import './index.styl'
</style>
